import './index.scss';
import React from 'react';
import { useDispatch } from 'react-redux';

import { showToast } from '@/src/globalFunction';

import { useMarkDelete } from '../../../api/markDelete';

const RestoreFolders = ({ file, onClose }) => {
  const dispatch = useDispatch();
  const markDeleteMutation = useMarkDelete();

  const handleRestore = async () => {
    const response = await markDeleteMutation.mutateAsync({
      itemIdsVersioned: [{ id: file.id, version: file.version }],
      inTrash: false,
    });

    if (response['error-results'].length > 0) {
      showToast('error', 'Something went wrong. Please try again later.');
    }

    if (response['conflict-results'].length > 0) {
      showToast('error', 'The document has already been upated. Please refresh and try again.');
    }

    dispatch({ type: 'RESET_SELECTED_ITEMS' });
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div
      className="modal restore-files-modal bg-overlay show in"
      data-backdrop="static"
      data-keyboard="false"
      id="restoreFolders"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bb pd20 pdl40 pdr40">
            <div className="row">
              <div className="col-lg-10 col-md-10 col-sm-10">
                <p className="text-size18 brndnTxt-m mb0 mt5">
                  The selected folder is in your Trash
                </p>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <a className="text-right" onClick={handleClose}>
                  <i className="material-icons text-black text-size22">close</i>
                </a>
              </div>
            </div>
          </div>
          <div className="modal-body">
            To view this folder, kindly restore it from your trash first.
          </div>
          <div className="modal-footer bt">
            <div className="footerActions">
              <div className="actionButton">
                <button type="button" className="btn btnCancel" onClick={handleClose}>
                  Cancel
                </button>
              </div>
              <div className="actionButton others">
                <button type="button" className="btnSend active" onClick={handleRestore}>
                  Restore
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestoreFolders;
